/**
 * Activation Completed Component
 * Based on Figma: https://www.figma.com/design/8nBzg5I71TF3EWyr6NcpVa/Fiat?node-id=5301-35629
 */
import { CircleCheck } from 'lucide-react';

import { Button } from '@components/ui/button';

interface ActivationCompletedProps {
  /**
   * Callback when "Start depositing" button is clicked
   */
  readonly onReturnToDeposits: () => void;
}

export function ActivationCompleted({
  onReturnToDeposits,
}: ActivationCompletedProps) {
  return (
    <div className="pt-5 sm:w-[394px]">
      {/* Content Section */}
      <div className="flex flex-col gap-3">
        {/* Success Icon with Concentric Circles */}
        <CircleCheck className="size-6" />
        <h2 className="text-foreground">Cash transfers activated</h2>
        <p className="text-muted-foreground text-body-paragraph1">
          You may now transfer funds to and from your bank account seamlessly.
        </p>
      </div>

      {/* Action Button */}
      <div className="mt-6 flex">
        <Button
          type="button"
          variant="primary"
          onClick={onReturnToDeposits}
          className="flex-1"
        >
          Return to deposits
        </Button>
      </div>
    </div>
  );
}
